import getSortedComponentsBySectionOrder, {
  ComponentItem,
} from "@/utils/getSortedComponentsBySectionOrder";

export default function renderSideRailContent({
  headerComponentsOrder,
  bodyComponentsOrder,
  components,
}: {
  headerComponentsOrder: string[];
  bodyComponentsOrder: string[];
  components: ComponentItem[];
}) {
  return (
    <>
      <div className="flex flex-col gap-4 p-4 bg-putty-300 rounded-t-xl">
        {getSortedComponentsBySectionOrder({
          componentList: components,
          sectionsOrder: headerComponentsOrder,
        })}
      </div>
      <div className="flex flex-col gap-4 p-4 bg-gradient-to-b from-[#D7D3C5] to-putty-300 rounded-b-xl">
        {getSortedComponentsBySectionOrder({
          componentList: components,
          sectionsOrder: bodyComponentsOrder,
        })}
      </div>
    </>
  );
}
